import { on } from "svelte/events";
import { os } from "@otto-ec/global-resources/device";

let initialized = false;
const result = $state({
  value: "0px",
});

const updateHeight = (): void => {
  const keyboardHeight = Math.max(0, window.innerHeight - window.visualViewport!.height);
  result.value = `${keyboardHeight}px`;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useKeyboardHeight = (isVisible: boolean): { value: string } => {
  if (!isVisible) {
    return result;
  }
  if (os === "Android" && !initialized && window && window.visualViewport) {
    initialized = true;
    updateHeight();
    on(window.visualViewport, "resize", updateHeight, { passive: true });
  }

  return result;
};
